export default __webpack_public_path__ + "static/media/limg.e68e2407.png";